// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section {
  display: block;
  flex: 1 0 auto;
  position: relative;
  width: 100%;
  transition: all 0.5s ease-in;
}

[data-theme='light'] section {
  background-color: #ebeaea;
}

.intro_sec {
  display: flex;
  height: auto;
  min-height: 600px;
  margin-top: auto;
  align-items: center;
}

.title-container {
  display: flex;
  font-size: 50px;
  font-family: 'Courier New', Courier;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  margin-top: 70px;
}

.h_bg-image {
  width: 40vw;
  min-height: 65vh;
  object-fit: scale-down;
  position: relative;
  filter: saturate(0.5);
  margin-left: 100px;
  border: 7px double rgb(49, 49, 46);
  box-sizing: border-box;
}


.animated-text {
  font-family: 'Courier New', Courier;
  font-size: 35px;
  color: rgb(45, 184, 154);
  margin-right: 70px;
  margin-left: 70px;
  font-weight: 700;
}

[data-theme='light'] .animated-text {
  color: #aa9e6f;
}

.text-description {
  font-family: 'Courier New', Courier;
  font-size: 20px;
  margin-right: 90px;
  margin-left: 90px;
  margin-top: 20px;
}

@media (max-width: 950px) {
  .intro_sec {
    min-height: auto;
    flex-direction: column;
  }

  .h_bg-image {
    width: 50%;
    min-height: 30vh;
    margin-left: 0px;
  }

  .title-container {
    font-size: 30px;
  }

  .animated-text {
    font-family: 'Courier New', Courier;
    font-size: 18px;
    text-align: center;
    margin-top: 5%;
  }

  .text-description {
    font-family: 'Courier New', Courier;
    font-size: 14px;
    margin-right: 90px;
    margin-left: 90px;
    margin-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;;AAGA;EACE,mCAAmC;EACnC,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mCAAmC;IACnC,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,mCAAmC;IACnC,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;AACF","sourcesContent":["section {\n  display: block;\n  flex: 1 0 auto;\n  position: relative;\n  width: 100%;\n  transition: all 0.5s ease-in;\n}\n\n[data-theme='light'] section {\n  background-color: #ebeaea;\n}\n\n.intro_sec {\n  display: flex;\n  height: auto;\n  min-height: 600px;\n  margin-top: auto;\n  align-items: center;\n}\n\n.title-container {\n  display: flex;\n  font-size: 50px;\n  font-family: 'Courier New', Courier;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 30px;\n  margin-top: 70px;\n}\n\n.h_bg-image {\n  width: 40vw;\n  min-height: 65vh;\n  object-fit: scale-down;\n  position: relative;\n  filter: saturate(0.5);\n  margin-left: 100px;\n  border: 7px double rgb(49, 49, 46);\n  box-sizing: border-box;\n}\n\n\n.animated-text {\n  font-family: 'Courier New', Courier;\n  font-size: 35px;\n  color: rgb(45, 184, 154);\n  margin-right: 70px;\n  margin-left: 70px;\n  font-weight: 700;\n}\n\n[data-theme='light'] .animated-text {\n  color: #aa9e6f;\n}\n\n.text-description {\n  font-family: 'Courier New', Courier;\n  font-size: 20px;\n  margin-right: 90px;\n  margin-left: 90px;\n  margin-top: 20px;\n}\n\n@media (max-width: 950px) {\n  .intro_sec {\n    min-height: auto;\n    flex-direction: column;\n  }\n\n  .h_bg-image {\n    width: 50%;\n    min-height: 30vh;\n    margin-left: 0px;\n  }\n\n  .title-container {\n    font-size: 30px;\n  }\n\n  .animated-text {\n    font-family: 'Courier New', Courier;\n    font-size: 18px;\n    text-align: center;\n    margin-top: 5%;\n  }\n\n  .text-description {\n    font-family: 'Courier New', Courier;\n    font-size: 14px;\n    margin-right: 90px;\n    margin-left: 90px;\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
